<template>
  <div class="calendar-week-container flex-start" :style="{'transform': `translateX(0)`}">
    <div v-for="(weekData, index) in fullWeekData" :key="index" class="calendar-week-content flex-between w-transition"
      :style="{'transform': `translateX(${( index - 1 + translateIndex) * 100 }%)`}"
      v-touch:swipeleft="calendarSwipeLeft" v-touch:swiperight="calendarSwipeRight">
      <template v-for="(item, vIndex) in weekData.data">
        <div class="week-num-item flex-column" :key="vIndex" @click="changeCurrentMonth(item, 'calendarMonth')">
          <span class="week-num flex-center"
            :class="[{'is-today': item.currentDateStr === currentTodayStr}, {'is-click-block': item.currentDateStr === currentMonth.dateFormatConnect}]">
            {{ item.currentDateNum | todayTextFilter(item) }}</span>
          <slot :name="item.currentDateStr" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getWeekData } from '../utils'
import { campusOfferMixin } from '../mixins'
const moment = require('moment')

export default {
  mixins: [campusOfferMixin],
  data () {
    return {
      currentTodayStr: moment().format('YYYY-MM-DD'),
      // fullWeekData: [[], [], []],
      translateIndex: -50
    }
  },
  props:['leftFlag', 'rightFlag'],
  mounted () {
    this.initWeekData()
  },
  components: {},
  watch: {
    leftFlag: {
      handler (newVal) {
        this.calendarSwipeLeft()
      }
    },
    rightFlag: {
      handler (newVal) {
        this.calendarSwipeRight()
      }
    }
  },
  methods: {
    initWeekData () {
      const WEEK_FOR_YEAR = 52
      const weekStart = moment().startOf('week')
      let fullWeekData = []
      // 当前周的数据
      let currentWeekData = getWeekData(weekStart).map(item => {
        return {
          currentDateStr: item,
          currentDateNum: item.slice(8) * 1
        }
      })
      fullWeekData = [
        {
          translateIndex: 0,
          data: currentWeekData
        }
      ]
      for (let i = 1; i < WEEK_FOR_YEAR; i++) {
        let prevStart = moment().startOf('week').subtract(i, 'weeks')
        let nextStart = moment().startOf('week').add(i, 'weeks')
        let prevWeekData = getWeekData(prevStart).map(item => {
          return {
            currentDateStr: item,
            currentDateNum: item.slice(8) * 1,
          }
        })
        let nextWeekData = getWeekData(nextStart).map(item => {
          return {
            currentDateStr: item,
            currentDateNum: item.slice(8) * 1,
          }
        })
        fullWeekData.unshift({
          translateIndex: -i,
          data: prevWeekData
        })
        fullWeekData.push({
          translateIndex: i,
          data: nextWeekData
        })
      }
      this.setFullWeekData(fullWeekData)
    },
    calendarSwipeLeft () {
      if (this.translateIndex > -101) {
        this.translateIndex -= 1
        let data = this.calcCurrentMonth()
        this.$emit('calendarMove', data, 'calendarMonth')
      }
    },
    calendarSwipeRight () {
      if (this.translateIndex < 1) {
        this.translateIndex += 1
        let data = this.calcCurrentMonth()
        this.$emit('calendarMove', data, 'calendarMonth')
      }
    },
    calcCurrentMonth () {
      this.setIsClick(false)
      let { data } = this.fullWeekData[-this.translateIndex + 1]
      if (data && data[0]) {
        this.setDefaultDateStr(data[0].currentDateStr)
        this.setCurrentSunday(data[0].currentDateStr)
      }
      return data
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../../assets/scss/global/variable';
@import '../../../assets/scss/global/mixin';
.calendar-week-container {
  width: 100vw;
  .calendar-week-content {
    position: absolute;
    top: 7px;
    width: 100vw;
    height: 28px;
    // padding: 0 18px;
    .week-num-item {
      $width: 375px / 7;
      width: $width;
      height: 38px;
      color: $color-title;
      margin-top: 7px;
      align-items: center;
      justify-content: space-between;
      .week-num {
        width: 28px;
        height: 28px;
        font-weight: 600;
      }
    }
    .is-today {
      background-color: #FFF6F4;
      color: $color-theme;
      border-radius: 50%;
    }
    .is-click-block {
      background-color: $color-theme;
      border-radius: 50%;
      color: $color-light;
    }
  }
}
</style>